import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    DISASSOCIATE_USER_ROLE: (userId, role) => ({ userId, role }),
    API: {
      DISASSOCIATE_USER_ROLE: apiResourceActionCreator('user/role/disassociate')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/user/role/disassociate`, authToken, payload, actions.admin.api.disassociateUserRole);

function* disassociateUserRole(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'disassociateUserRole',
  action: actions,
  sagas: disassociateUserRole,
  reducers: {
    request: (state, action) => ({
      ...state,
      isDisassociatingUserRole: true,
      error: null
    }),
    success: (state, action) => ({
      ...state,
      isDisassociatingUserRole: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isDisassociatingUserRole: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/disassociateUserRole.js